import axios from 'axios'
import { notifySuccess, deleteEmptyKey } from 'utils/common'

class System {
  constructor (data) {
    this.id = data.id
    this.name = data.name // string 系统名称
    this.type = data.systemType // number 系统类型，1-太阳能，2-市电，3-智能开关
    this.accessKey = data.accessKey // string 授权码
    this.secretKey = data.secretKey // string 安全码
    this.gatewaySnEffectiveInterval = data.gatewaySnEffectiveInterval // string 网关sn号的有效区间，用'-'分隔
    this.nodeSnEffectiveInterval = data.nodeSnEffectiveInterval // string 节点sn号的有效区间，用'-'分隔
    this.createdAt = data.createdAt || '' // date 创建日期
  }
}

/**
 * 获取系统列表,作为下拉数据
 * @returns {Array}
 */
export const getOptions = async () => {
  const { data } = await axios.get('v1/sub-systems')
  return data.map(item => {
    return {
      label: item.name, // string
      value: item.id // number
    }
  })
}

/**
 * 获取系统列表
 * @param  {Number} systemType 系统类型，1-太阳能，2-市电，3-智能开关
 * @param  {String} name 系统名称（模糊查询条件）
 * @param  {String} username 用户名
 */
export const getList = async (options) => {
  const params = deleteEmptyKey(options)
  const { data } = await axios.get('v1/device-systems', { params })
  return data.map(item => new System(item))
}

/**
 * 获取单个系统详细信息
 * @param {*Number} systemId
 * @return {Object}
 */
export const getData = async (systemId) => {
  const { data } = await axios.get(`v1/device-systems/${systemId}`)
  return new System(data)
}

/**
 * 新增系统
 * @param {*Object} data
 * @return {Object}
 */
export const create = async (data) => {
  await axios.post('v1/device-systems', data)
  notifySuccess('新增成功')
}

/**
 * 更新系统
 * @param {*Number} systemId 需要更新的系统id
 * @param {*Object} data 更新数据
 */
export const update = async (systemId, data) => {
  await axios.put(`v1/device-systems/${systemId}`, data)
  notifySuccess('修改成功')
}

/**
 * 关联系统到用户
 * @param {*Number} systemId 需要关联的系统id
 * @param {*Object} data 关联数据
 */
export const correlateToUser = async (systemId, data) => {
  await axios.post(`v1/device-systems/${systemId}`, data)
  notifySuccess('关联成功')
}
